import { GET_EMAILS_AND_SMS } from '../../../../graphql'
import { MemberMessageLayout } from '../../components'
import { EmailsAndSMSTabContent } from './components'

export const EmailsAndSMS = () => {
  return (
    <MemberMessageLayout
      headerTranslationId="pages.messagesPage.emailsAndSms.label"
      memberMessagesKey="memberEmailsAndSms"
      query={GET_EMAILS_AND_SMS}
      TabContentElement={EmailsAndSMSTabContent}
    />
  )
}
